import { render } from "./StockAssembleDetail.vue?vue&type=template&id=efc14eae"
import script from "./StockAssembleDetail.vue?vue&type=script&lang=js"
export * from "./StockAssembleDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__